/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TaskMoved/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import Tysiav2TaskMovedIcon from 'DesignSystem/Svgs/Tysiav2TaskMovedIcon/index'



/** @type {import('Simple/types.js').View} */
export default function TaskMoved({
  children,
  viewPath = "/App/Account/Topbar/Inbox/Content/Content/Messages/Unread/Content/Message/MessageTypeIcon/TaskMoved"
  
}) {
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
  return (<React.Fragment
>
<Tysiav2TaskMovedIcon
  viewPath={`${viewPath}/Tysiav2TaskMovedIcon`}
 width={14}
 height={14}
 fill={dtColorsNeutral500}
/>
{children}
</React.Fragment>)
}